var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8 col-md-offset-4" }, [
        _c(
          "label",
          {
            staticStyle: {
              width: "100%",
              "text-align": "right",
              padding: "9px 0px",
              "font-size": "13px",
              "font-weight": "600",
            },
            attrs: { id: "labelColeta" },
          },
          [_vm._v(_vm._s(_vm.obterMensagemColeta()))]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  !this.dashInfo.existeColeta ||
                  this.dashInfo.existeColetaPendente,
                expression:
                  "!this.dashInfo.existeColeta || this.dashInfo.existeColetaPendente",
              },
            ],
            staticClass: "col-md-12",
            staticStyle: {
              "font-size": "40px",
              "z-index": "999",
              "text-align": "center",
            },
            attrs: { id: "msgcoleta" },
          },
          [_c("label", [_vm._v(_vm._s(_vm.obterMensagemSemColeta()))])]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { style: _vm.desabilitar() }, [
        _c(
          "div",
          { attrs: { id: "tilesContent" } },
          _vm._l(this.dashInfo.taxTiles, function (tile) {
            return _c(
              "div",
              { key: tile.name, staticClass: "col-md-6 col-lg-3" },
              [
                _c("ui-tile", {
                  attrs: {
                    id: "tileICMS",
                    title: tile.name,
                    "color-title": "gray",
                    description: tile.coverDescription,
                    "value-field": tile.coverValue,
                    "color-theme": _vm.obterCorFonteTile(tile.result),
                    "icon-main": "fa fa-balance-scale",
                    "color-icon-search": "gray",
                    align: "right",
                    "is-money": "",
                    "visibility-perc": "hidden",
                    "additional-desc-value": tile.data,
                    link: tile.linkDetalhes,
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("tributos-ui-calendar", {
              attrs: {
                icon: "fa fa-calendar",
                title: _vm.dashInfo.calendarTitle,
                events: _vm.dashInfo.eventos,
              },
              on: {
                "bc-date-change": function ($event) {
                  _vm.mesSelecionado = $event
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }